<template lang="html">
  <div class="new-ad-wrapper-background">
    <div class="new-ad-wrapper">
      <manual :params="params" :custom="true" :manualInfo="manualInfo" />
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
import Manual from '@/components/manual/manual.vue'
export default {
  name: 'NewAd',
  components: {
    Manual
  },
  data () {
    return {
      manualInfo: {
        manualTitle: 'PAMETNA KUPOVINA',
        manualSteps: [
          {
            manualTitle: 'profile.purchase.basicInfo',
            component: 'BasicInfo'
          },
          {
            manualTitle: 'profile.purchase.detailsInfo',
            component: 'detailsInfo'
          },
          {
            manualTitle: 'profile.purchase.rightsInfo',
            component: 'rightsInfo'
          }
        ]
      },
      params: {},
      alloweLeave: false
    }
  },
  mounted () {
    eventBus.$on('finish', () => {
      this.finish()
    })
    eventBus.$on('changeNewAdParams', data => {
      this.changeNewAdParams(data)
    })
    eventBus.$on('changeNewAdImage', data => {
      this.changeNewAdImage(data)
    })
    window.onbeforeunload = confirmExit
    function confirmExit () {
      return 'If you leave all progress will be lost, are you sure you want to leave?'
    }
    eventBus.$on('logout', () => {
      window.onbeforeunload = null
      this.alloweLeave = true
    })
  },
  methods: {
    finish () {
      var formData = new FormData()
      for (var key in this.params) {
        if (key === 'prices' || key === 'socials') {
          formData.append(key, JSON.stringify(this.params[key]))
        } else if (key === 'images') {
          for (var i = 0; i < this.params.images.length; i++) {
            formData.append('images', this.params.images[i])
          }
        } else if (key === 'pro_quality') {
          for (i = 0; i < this.params.pro_quality.length; i++) {
            formData.append('pro_quality', this.params.pro_quality[i])
          }
        } else if (key === 'pro_declaration') {
          for (i = 0; i < this.params.pro_declaration.length; i++) {
            formData.append('pro_declaration', this.params.pro_declaration[i])
          }
        } else {
          formData.append(key, this.params[key])
        }
      }
      console.log(formData)
      eventBus.$emit('showLoader', true)
      api
        .createProduct(formData)
        .then(res => {
          console.log(res)
          eventBus.$emit('showLoader', false)
          this.$toast.success(this.$t('main.successfulCreation'), {
            duration: 8000
          })
          let params = Object.assign({}, this.$route.params)
          window.onbeforeunload = null
          this.alloweLeave = true
          setTimeout(() => {
            this.$router.push({ name: 'Home', params: params })
          }, 100)
        })
        .catch(e => {
          eventBus.$emit('showLoader', false)
          if (e.response.data.status === 'restricted_words') {
            let words = ''
            for (var i = 0; i < e.response.data.name_words.length; i++) {
              words += e.response.data.name_words[i]
              if (e.response.data.name_words[i + 1]) {
                words += ', '
              }
            }
            this.$toast.error(
              this.$t('main.errorCreationRestrictedWords') + words,
              {
                duration: 8000
              }
            )
          } else if (e.response.data.status === 'timeout') {
            this.$toast.error(this.$t('main.timeoutError'), {
              duration: 8000
            })
          } else if (
            e.response.data.validation &&
            e.response.data.validation === 'required'
          ) {
            this.$toast.error(this.$t('main.errorCreationMissing'), {
              duration: 8000
            })
          } else {
            this.$toast.error(this.$t('main.errorCreation'), {
              duration: 8000
            })
          }
        })
    },
    changeNewAdParams (data) {
      if (data.key === 'filters') {
        if (data.value === false) {
          delete this.params.filters
        } else {
          let res = []
          for (var variable in data.value) {
            if (data.value.hasOwnProperty(variable)) {
              let obj = {
                cha_id: data.value[variable].cha_id,
                cha_datatype: data.value[variable].cha_datatype,
                cvl_id: data.value[variable].value
              }
              res.push(obj)
            }
          }
          this.params[data.key] = JSON.stringify(res)
        }
      } else {
        if (data.value) {
          if (
            Object.keys(data.value).length === 0 &&
            data.key === 'pro_declaration'
          ) {
            console.log('a')
            delete this.params[data.key]
          } else {
            this.params[data.key] = data.value
          }
        } else {
          delete this.params[data.key]
        }
      }
    },
    changeNewAdImage (data) {
      console.log(data, 'asd')
      if (data.key === 'main_image') {
        delete this.params[data.key]
        let res = {
          key: data.key,
          value: []
        }
        eventBus.$emit('fixPreviews', res)
      } else {
        console.log(data, 'asd')
        console.log('params -- ' + JSON.stringify(this.params[data.key]))
        for (var i = 0; i < this.params[data.key].length; i++) {
          console.log(this.params[data.key][i])
          if (this.params[data.key][i].name === data.value) {
            this.params[data.key].splice(i, 1)
          }
        }
        console.log(this.params[data.key][0])
        console.log(
          'this.params[data.key].length ' + this.params[data.key].length
        )

        if (data.key === 'images') {
          return
        }
        let res = {
          key: data.key,
          value: this.params[data.key]
        }
        eventBus.$emit('fixPreviews', res)
      }
    }
  },
  destroyed () {
    eventBus.$off('finish')
    eventBus.$off('changeNewAdParams')
    eventBus.$off('changeNewAdImage')
    eventBus.$off('logout')
    this.params = {}
    window.onbeforeunload = null
  },
  beforeRouteLeave (to, from, next) {
    if (this.alloweLeave) {
      next()
    } else {
      let modalData = {
        title: this.$t('main.preventLeave'),
        ok: () => {
          next()
        },
        cancel: () => {
          next(false)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    }

    // const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    // if (answer) {
    //   next()
    // } else {
    //   next(false)
    // }
  }
}
</script>

<style lang="scss" scoped>
.new-ad-wrapper-background {
  background: #f2f2f2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;

  .new-ad-wrapper {
    height: 100%;
    max-width: 1600px;
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: white;
    padding: 40px;
    box-sizing: border-box;
    align-items: flex-end;
  }
}
@media only screen and (max-width: 767px) {
  .new-ad-wrapper-background {
    background: #f2f2f2;
    padding-top: 30px;
    padding-bottom: 60px;
    width: 100%;

    .new-ad-wrapper {
      height: 100%;
      max-width: 1600px;
      width: calc(100% - 18px);
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      background: white;
      padding: 9px;
      box-sizing: border-box;
      align-items: flex-end;
    }
  }
}
</style>
<style media="screen" lang="scss">
.new-ad-wrapper {
  .manual-wrapper {
    width: 100%;
    box-sizing: border-box;
    margin: 30px auto;
    padding: 0px;
    max-width: 900px;

    .manual-navigation-wrapper {
      max-width: 300px;
      width: 300px;
    }
  }
}
</style>
